module.exports = __webpack_public_path__ + "img/Icon_registro.7a0a7a01.svg";